package com.perpheads.bans.responses

import kotlinx.serialization.Serializable

@Serializable
data class RankResponse(
    val rankId: Int,
    val name: String,
    val immunity: Int
)